<template>
  <v-dialog v-model="isVisible" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline py-2">
        Выбор исполнителя
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="onCancel()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p v-if="message">{{message}}</p>
        <v-combobox
          label="Исполнитель"
          :items="executorsList"
          v-model="values"
          item-text="name"
          item-value="id"
          chips
          clearable
          :menu-props="{ maxHeight:'auto' }"
          hint=""
          persistent-hint
          :loading="loading"
        >
          <template slot="selection" slot-scope="{ item, parent, selected }">
            <v-chip
              @input="parent.selectItem(item)"
              :selected="selected"
              class="chip--select-multi"
              :key="JSON.stringify(item)"
            >
              <v-avatar>
                <img v-if="item.photo" :src="item.photo"/>
                <v-icon v-else>mdi-account-circle</v-icon>
              </v-avatar>
              {{ item.fullname ? item.fullname : item.name }}
            </v-chip>
          </template>
          <template slot="item" slot-scope="{ index, item }">
            <template v-if="item === Object(item)">
              <v-list-tile-avatar>
                <img v-if="item.photo" :src="item.photo"/>
                <v-icon v-else>mdi-account-circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.fullname ? item.fullname : emptyPost }}</v-list-tile-title>
                <v-list-tile-sub-title v-if="item.name" v-html="item.name"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-combobox>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="success" @click.native="onConfirm()" :disabled="values === null">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import monitor from '../../mixins/monitor'

export default {
  mixins: [monitor],

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'accent'
    },
    confirmText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Отменить'
    },
    emptyPost: {
      type: String,
      default: "Назначение на пост отсутствует"
    }
  },

  data() {
    return {
      executorsList: [],
      isVisible: this.visible,
      values: null
    }
  },

  computed: {
    fakeAvatar: function() {
      return this.$store.getters['app/faker/avatar']()
    }
  },

  watch: {
    visible: function (newVal) {
      this.isVisible = newVal

      if (!this.isVisible) {
        this.values = null
      }
    },
    list: function () {
      this.init()
    },
    // values: function () {
    //   console.log("values changed:")
    //   console.log(this.values)
    // }
  },

  mounted() {
    this.init()
  },

  methods: {
    init: function () {
      if (Array.isArray(this.list) && this.list.length) {
        // Load posts & containers info by its IDs
        this.$store.dispatch('app/org/entitiesInfo', { posts: this.list, containers: [] }).then(response => {
          const postsData = response.posts_data
            ? response.posts_data
            : []

          this.executorsList = []
          // // TODO: Replace broken or empty avatar
          // postsData.forEach(user => {
          //   if (!user.photo || user.photo === 'http://anketa.lsc/storage/user.png') {
          //     user.photo = this.fakeAvatar
          //   }
          //   this.executorsList.push(user)
          // })

          this.executorsList = response.posts_data
            ? response.posts_data
            : []
        }).catch( error => {
          console.warn(error)
        })
      }
    },

    onCancel: function () {
      this.$emit('cancel')
    },
    onConfirm: function () {
      this.$emit('confirm', true, this.values)
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/components/ExecutorsModal.vue